import { sendToDatadog } from '@shoflo/polymer';
import {
  toggleProgramSource,
  deleteMeetingAttendee
} from '@shoflo/studio-redux/actions';
import { BROADCAST_DELETE_SOURCE } from '@shoflo/studio-redux/actions/types';
import { setProgram } from 'actions/program';

import { withCurrentParams } from 'utils/actionUtils';
import { CAMERA_PRESENTER, UNASSIGNED } from '@studio/constants';

function deleteSource(sourceId) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const action = {
        type: BROADCAST_DELETE_SOURCE,
        request: async apiClient => {
          const {
            broadcastSources,
            program: { layers = [] }
          } = getState();

          const [source] = broadcastSources.sources.filter(
            bs => bs._id === sourceId
          );

          const isSourceInProgram = layers.some(
            layer => layer.source._id === sourceId
          );

          // Remove source from program
          if (isSourceInProgram) {
            dispatch(toggleProgramSource(source, setProgram));
          }

          await apiClient.broadcast.deleteSource(
            teamId,
            eventId,
            broadcastId,
            sourceId
          );

          const logMessage = isSourceInProgram
            ? `Removed sourceId: ${sourceId} from stage and deleted it`
            : `Deleted sourceId: ${sourceId}`;

          sendToDatadog('Source', { source }, logMessage, false);

          // delete attendee from chime meeting
          if (source.type === CAMERA_PRESENTER && source.value !== UNASSIGNED) {
            dispatch(deleteMeetingAttendee(source.value));
          }
          return source;
        }
      };
      dispatch(action);
    }
  );
}

export default deleteSource;
